import {
  getShipmentInfoFromStops,
  dateFormatter,
  stopRenderer,
  warningRenderer,
  renderShipperOrderShippers,
} from '../utils';

const ES_template = (journey, offerLink) => {
  const { shipper_orders, stops, start_time_from, end_time_to, extras, net_full_cost, id } =
    journey;

  const country = 'ES';
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const when = dateFormatter(start_time_from, end_time_to, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const shippers = renderShipperOrderShippers(shipper_orders);
  const deepLink = `${offerLink}${id}`;

  return `
¿Quieres este trabajo? ${id}
COBRAS
${net_full_cost} € IVA no incl.

CUÁNDO
${when}

EMPRESA
${shippers}

${stopsInfo.shipmentType}
${stopsInfo.PICKUP} Recogida(s), ${stopsInfo.DROPOFF} Entrega(s)
${stopsToRender}
${warning}

Si tienes la app instalada haz click aquí para aceptarla:
${deepLink}

O responde a este mensaje escribiendo LO QUIERO
  `;
};

export default ES_template;
